export const formatClassString = (classesArray: (string | undefined | false)[]): string => {
  return classesArray.filter((x) => !!x).join(' ')
}
